import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAuthMemberKey, getAuthMemberSessionsKey } from '../../utils/keys';
export const useLogout = (options) => {
    const { useMutationOptions } = options || {};
    const queryClient = useQueryClient();
    const { client } = useTribeClient();
    return useMutation(input => client.auth.logout(input), {
        onMutate: variables => {
            const authMemberSessionKey = getAuthMemberSessionsKey();
            queryClient.setQueriesData(authMemberSessionKey, old => ({
                ...old,
                sessions: old.sessions.filter(session => session.id !== variables.input.sessionId),
            }));
        },
        onSettled: () => {
            const authMemberKey = getAuthMemberKey();
            queryClient.invalidateQueries(authMemberKey);
            const authMemberSessionKey = getAuthMemberSessionsKey();
            queryClient.invalidateQueries(authMemberSessionKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useLogout.js.map